/**
 * Gate web club self-registration while invitation-based join is built on club-selector.
 * Mobile parity: ConnectMobileProfile + invitation code (see FM_MobileApp useJoinClub).
 */
export const CLUB_SELF_REGISTRATION_DISABLED = true

/** Hide merge-accounts entry on club-selector until the flow is ready for release. */
export const MERGE_ACCOUNTS_UI_ENABLED = false

/** Hide auth layout sponsor panel ("Thanks to our sponsors") until re-enabled. */
export const AUTH_SPONSORS_UI_ENABLED = false

export const CLUB_SELECTOR_PATH = '/auth/club-selector'
